import VerifiedUser from "../models/verifiedUser";
const bgImage =  require("../../card.png")
const ImageDrawer = (img:any,list:Array<VerifiedUser>) => {
        return new Promise<string>((resolve, reject) => {
            if(list.length===0){
                resolve('')
            }

            let canvas = document.createElement("canvas");
            const image = new Image(518,  268); // Using optional size for image
            canvas.width = image.width;
            canvas.height = (image.height) * list.length;
            let ctx: any = canvas.getContext("2d");

            ctx.fillStyle = "#000000";
            ctx.font = "16px b Yekan";
            ctx.fontWeight = '400'
            ctx.direction = "rtl"

            image.onload = (event) => {
                list.forEach((vUser,index)=>{

                    ctx.drawImage(image, 0, (index*image.height)+(index*10), image.width, image.height);


                    ctx.fillText('نام :  ' + vUser.firstName, 450, (index*268) + 130);
                    ctx.fillText('نام خانوادگی :  ' + vUser.lastName, 250, (index*268) + 130);
                    ctx.fillText('تاریخ تولد : ' + vUser.birthDate, 450, (index*268) + 180);
                    ctx.fillText('کد ملی : ' + vUser.nationalCode, 250, (index*268) + 180);
                    if(index===list.length-1){

                        resolve(canvas.toDataURL())
                    }

                })


                /*
                            ctx.fillText('نام :  ' + vUser.firstName, 450, (index + 1) * 130);
                            ctx.fillText('نام خانوادگی :  ' + vUser.lastName, 250, (index + 1) * 130);
                            ctx.fillText('تاریخ تولد : ' + vUser.birthDate, 450, (index + 1) * 180);
                            ctx.fillText('کد ملی : ' + vUser.nationalCode, 250, (index + 1) * 180);*/
                /*list.forEach((vUser, index) => {
                    ctx.drawImage(image, 0, 0, image.width, (index + 1)*image.height);
                    ctx.fillStyle = "#000000";
                    ctx.font = "16px b Yekan";
                    ctx.fontWeight = '400'
                    ctx.direction = "rtl"
                    ctx.fillText('نام :  ' + vUser.firstName, 450, (index + 1) * 130);
                    ctx.fillText('نام خانوادگی :  ' + vUser.lastName, 250, (index + 1) * 130);
                    ctx.fillText('تاریخ تولد : ' + vUser.birthDate, 450, (index + 1) * 180);
                    ctx.fillText('کد ملی : ' + vUser.nationalCode, 250, (index + 1) * 180);
                });*/


            };
            image.src = bgImage;
     /*       resolve(canvas.toDataURL().toString())*/
        })
}
/*const VerifiedUserImage = async (img:any,list:Array<VerifiedUser>): Promise<string> => {
    return new Promise<string>((resolve) => {
        resolve('4');
    });
};*/
export default ImageDrawer